import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import AnchorButton from "../../components/AnchorButton";
import { oneLink } from "../../shared/oneLink";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";

interface SubscriptionChangeFinishPageProps {
    planTitle: string;
}
const SubscriptionChangeFinishPage = (
    props: SubscriptionChangeFinishPageProps
) => {
    return (
        <MainLayout>
            <Headline>プラン変更完了</Headline>
            <section className="payment-make-finish">
                <p className="finish-message">
                    パートナーエージェントAppの{props.planTitle}
                    への変更が完了しました！
                    <br />
                    アプリを開いて引き続きサービスをご利用ください。
                </p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default SubscriptionChangeFinishPage;
